<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    :title="title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="beforeSave"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-input :model="$schema.name" />
      </div>

      <div class="form-group col-12">
        <w-textarea :model="$schema.description" />
      </div>

      <div class="form-group col-12">
        <w-select :values="CriterionTypeList" :model="$schema.type" />
      </div>

      <div class="form-group col-12">
        <w-select :values="CriterionCalculateTypeList" :model="$schema.calculateType" />
      </div>

      <div v-if="$schema.$model.type === CriterionType.SCORE" class="form-group col-12">
        <w-input :model="$schema.minimumRequired" />
      </div>

      <div v-if="$schema.$model.type === CriterionType.SCORE" class="form-group col-12">
        <w-input :model="$schema.maximum" />
      </div>

      <div class="form-group col-12">
        <w-checkbox :model="$schema.validate" />
      </div>

      <div class="form-group col-12">
        <w-textarea :model="$schema.formula" />
      </div>

      <div class="form-group col-12">
        <w-monaco v-if="show" :model="$schema.autoFunction" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { CriterionCalculateTypeList } from '@/enums/criterionCalculateType.enum';
import { CriterionType, CriterionTypeList } from '@/enums/criterionType';
import { EntityType } from '@/enums/entityType.enum';
import { formMixin } from '@/mixins/form';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/criterion.schema';
import { tryParseInt } from '@/utils/number';

const emptyData = () => ({
  name: null,
  type: null,
  minimumRequired: null,
  maximum: null,
  validate: false,
  stageId: null,
  statusId: null,
  parentId: null,
  formula: null,
  description: '',
  autoFunction: null
});

// @vuese
// Modal dodania kryterium
// @group Criterion
export default {
  mixins: [manageMixin('criterion', {}, emptyData), formMixin],
  schema,
  props: {
    // Id rodzica struktury
    parentId: {
      type: Number,
      required: false,
      default: undefined
    },
    // Typ encji
    entityType: {
      type: String,
      required: true
    }
  },
  data() {
    return { model: {}, CriterionTypeList, CriterionType, CriterionCalculateTypeList };
  },
  computed: {
    title() {
      return this.id ? 'Edycja kryterium' : 'Dodawanie kryterium';
    }
  },
  methods: {
    // @vuese
    // Uzupełnienie danych z routingu przed zapisem
    beforeSave() {
      if (this.entityType === EntityType.STAGE) {
        this.$schema.stageId.$model = tryParseInt(this.$route.params.stageId);
      }
      if (this.entityType === EntityType.STATUS) {
        this.$schema.statusId.$model = tryParseInt(this.$route.params.statusId);
      }
      this.$schema.$setData({ parentId: this.parentId });

      this.save();
    }
  }
};
</script>
